import { useState, useCallback } from "react";

const API_BASE_URL = "https://psgc.gitlab.io/api";

export const useAddressAPI = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchAPI = useCallback(async (endpoint) => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(`${API_BASE_URL}${endpoint}`);
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await response.json();
      return data;
    } catch (e) {
      setError(e.message);
      console.error("Failed to fetch address data", e);
      return [];
    } finally {
      setLoading(false);
    }
  }, []);

  const getRegions = useCallback(() => {
    return fetchAPI("/regions/");
  }, [fetchAPI]);

  const getProvinces = useCallback(
    (regionCode) => {
      if (!regionCode) return Promise.resolve([]);
      return fetchAPI(`/regions/${regionCode}/provinces/`);
    },
    [fetchAPI]
  );

  const getCities = useCallback(
    (provinceCode) => {
      return fetchAPI(`/provinces/${provinceCode}/cities-municipalities/`);
    },
    [fetchAPI]
  );

  const getBarangays = useCallback(
    (cityCode) => {
      return fetchAPI(`/cities-municipalities/${cityCode}/barangays/`);
    },
    [fetchAPI]
  );

  const getDistricts = useCallback(
    (cityCode) => {
      return fetchAPI(`/cities-municipalities/${cityCode}/districts/`);
    },
    [fetchAPI]
  );

  return {
    loading,
    error,
    getRegions,
    getProvinces,
    getCities,
    getBarangays,
    getDistricts,
  };
};
